import { toAcres } from 'util/conversions';
import { getHarvestedFlag } from 'common/utils';

export function getFieldsListFromData(data) {
  // NB: response objects from Apollo are immutable, so we need to make deep copies to support the original implementation.
  const { getAllFields: fields, getAllCropsForField: crops } = data;

  const fieldsWithCrops = fields.map(field => {
    const fieldCrops = crops.filter(crop => crop.fieldName === field.name);
    return {
      ...field,
      plantedArea: 0,
      harvested: getHarvestedFlag(fieldCrops),
      crops: fieldCrops,
    };
  });

  // sort the fields in descending order of plantedArea
  fieldsWithCrops.sort(
    (field1, field2) => field1.plantedArea < field2.plantedArea
  );

  // sort the crops list for each fields
  fieldsWithCrops.forEach(field =>
    field.crops.sort(
      (crop1, crop2) =>
        toAcres(crop1.plantedArea.size, crop1.plantedArea.type) <
        toAcres(crop2.plantedArea.size, crop2.plantedArea.type)
    )
  );

  return fieldsWithCrops;
}



// WEBPACK FOOTER //
// ./src/api/util.js